export default "__VITE_ASSET__B16frxoH__"